/*
We leave chapter data caching to tanstack, and wrap its functions accordingly
 */

import type { ChapterEntity } from "~/src/api";
import type { QueryClient } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";

export const getReaderChapter = (
  queryClient: () => QueryClient,
  chapterId: MaybeRef<string>,
  auth?: AuthFunction,
) => {
  return useQuery(
    {
      ...useChapterGet(chapterId, ["organization", "user"], auth),
      placeholderData: () => {
        const cached = getSingleEntityFromCache(
          queryClient().getQueryCache(),
          "chapter",
          unref(chapterId),
        ) as ChapterEntity | undefined;
        if (cached) {
          return cached;
        }
      },
    },
    queryClient(),
  );
};
